module.exports = __webpack_public_path__ + "img/minus-circle.18264c57.svg";